export default {"src":"/_next/static/media/trek.db24f382.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};